module.exports = __webpack_public_path__ + "img/ctrl-a-stub-down--i.6227ba33.svg";